import { render, staticRenderFns } from "./CriarTabela.vue?vue&type=template&id=7490e978&"
import script from "./CriarTabela.vue?vue&type=script&lang=js&"
export * from "./CriarTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports